import { Component, Inject, OnInit, Optional } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { UtilityService } from '@app/core/services/utility.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { P2SubscriptionItem, P2SubscriptionService, P2SubscriptionSettingsGet } from '@app/services/p2-subscription.service';

@Component({
    selector: 'tt-p2-subscription',
    templateUrl: './p2-subscription.component.html',
    styleUrls: ['./p2-subscription.component.css'],
    standalone: false,
})
export class P2SubscriptionComponent implements OnInit {
    public setting?: P2SubscriptionSettingsGet;

    public subscriptions: P2SubscriptionItem[] = [];

    public itemState = '';

    public selectedSubscriptionKeyno = '';

    public readonly tabletSize: MediaQueryList;

    private navigator?: TTViewNavigator;

    constructor(
        private subscriptionService: P2SubscriptionService,
        private utility: UtilityService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async loadSubscriptions(): Promise<void> {
        this.subscriptions = await this.subscriptionService.listSubscriptions();
        this.itemState = this.subscriptions.find((item) => !!item.item_state)?.item_state ?? '';
    }

    public async updateList(): Promise<void> {
        this.selectedSubscriptionKeyno = '';
        await this.loadSubscriptions();
    }

    public openSubscription(item: P2SubscriptionItem, event?: MouseEvent): void {
        const keyno = `${item.item_id}`;

        if (this.tabletSize.matches && this.itemState === 'p2subscriptionedit') {
            this.selectedSubscriptionKeyno = keyno;
            return;
        }

        this.navigateToEdit(keyno, event);
    }

    public createSubscription(event?: MouseEvent): void {
        if (this.tabletSize.matches && this.itemState === 'p2subscriptionedit') {
            this.selectedSubscriptionKeyno = '0';
            return;
        }

        this.navigateToEdit('0', event);
    }

    public ngOnInit(): void {
        void this.init();
    }

    private async init(): Promise<void> {
        const [setting] = await Promise.all([
            this.subscriptionService.getSettings(),
            this.loadSubscriptions(),
        ]);

        this.setting = { ...setting, searchtext: setting.searchtext ?? '' };
    }

    private navigateToEdit(keyno: string, event?: MouseEvent): void {
        const target = {
            to: 'p2subscriptionedit',
            parms: { p2_subscription_keyno: keyno }
        };

        if (event && this.navigator && this.utility.isModifierKeyPressed(event)) {
            void this.navigator.newTab(target);
        } else {
            void this.navigator?.go(target);
        }
    }
}
